import { render, staticRenderFns } from "./UpdateRouteOfAdministation.vue?vue&type=template&id=07973416&scoped=true&"
import script from "./UpdateRouteOfAdministation.vue?vue&type=script&lang=js&"
export * from "./UpdateRouteOfAdministation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRouteOfAdministation.vue?vue&type=style&index=0&id=07973416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07973416",
  null
  
)

export default component.exports